module.exports = __webpack_public_path__ + "static/media/img_hero-define-1.6eb51868.png";